var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { mapGetters } from "vuex";
import CommonService from "../../api/CommonService";
import { Loading } from 'element-ui';
import ShoppingManageService from '../../api/ShoppingManageService';
import Header from "./components/purchaseTime/Header.vue";
import EditDialog from "./components/purchaseTime/EditDialog.vue";
import ImportDialog from "./components/purchaseTime/ImportDialog.vue";
var PurchaseTime = (function (_super) {
    __extends(PurchaseTime, _super);
    function PurchaseTime() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.listData = [];
        _this.total = 0;
        _this.selectRows = [];
        _this.searchParams = {};
        _this.dialogImportVisible = false;
        _this.isImportSuccessHandled = false;
        _this.tableHeight = 300;
        return _this;
    }
    PurchaseTime.prototype.created = function () {
        this.service = ShoppingManageService.getInstance();
        this.commonService = CommonService.getInstance();
    };
    PurchaseTime.prototype.mounted = function () {
        var _this = this;
        setTimeout(function () {
            _this.tableHeight = document.documentElement.clientHeight - 272;
        }, 300);
    };
    PurchaseTime.prototype.search = function (params) {
        this.searchParams = params || {};
        this.$refs.pagination.clear();
        this.getList();
    };
    PurchaseTime.prototype.getList = function (pager) {
        var _this = this;
        pager = pager ? pager : this.$refs.pagination.getPage();
        var loadingInstance = Loading.service({ fullscreen: true });
        var params = Object.assign({}, pager, this.searchParams);
        this.service.getListPurchasetime(params).then(function (res) {
            loadingInstance.close();
            var Data = Array.isArray(res.data.data) ? res.data.data : [];
            Data.forEach(function (item) {
                item.day_week_name = item.day_week_name ? item.day_week_name.join('、') : '';
            });
            _this.listData = Data;
            _this.total = res.data.total;
            window._czc.push(["_trackEvent", '订货时段设置搜索', '订货时段设置搜索']);
        }).catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.message);
        });
    };
    PurchaseTime.prototype.pageChange = function (pager) {
        this.getList(pager);
    };
    PurchaseTime.prototype.add = function () {
        var _this = this;
        var instance = this.$dialog(EditDialog, {
            data: {}
        }, {
            title: "添加时段",
            width: 640,
            height: 500
        }).instance;
        instance.$on("editDialog:ok", function () {
            _this.search();
        });
    };
    PurchaseTime.prototype.edit = function (row) {
        var _this = this;
        var instance = this.$dialog(EditDialog, {
            data: {
                purchase_time_id: row.purchase_time_id
            }
        }, {
            title: "编辑时段",
            width: 640,
            height: 500
        }).instance;
        instance.$on("editDialog:ok", function () {
            _this.getList();
        });
    };
    PurchaseTime.prototype.del = function (row) {
        var _this = this;
        this.$confirm("是否要删除？").then(function () {
            var loadingInstance = Loading.service({ fullscreen: true });
            var params = {
                purchase_time_ids: row.purchase_time_id
            };
            _this.service.delPurchasetime(params).then(function (res) {
                loadingInstance.close();
                _this.$message.success("删除成功");
                _this.getList();
                window._czc.push(["_trackEvent", '订货时段设置删除', '订货时段设置删除']);
            }).catch(function (err) {
                loadingInstance.close();
                _this.$message.error(err.msg || err.message);
            });
        }, function (err) { });
    };
    PurchaseTime.prototype.selectionChange = function (rows) {
        this.selectRows = rows;
    };
    PurchaseTime.prototype.batchDelete = function () {
        var _this = this;
        if (this.selectRows.length === 0) {
            this.$message.warning('请选择要删除的数据');
            return;
        }
        this.$confirm("\u786E\u5B9A\u8981\u5220\u9664\u9009\u4E2D\u7684" + this.selectRows.length + "\u6761\u6570\u636E\u5417\uFF1F").then(function () {
            var loadingInstance = Loading.service({ fullscreen: true });
            var ids = _this.selectRows.map(function (item) { return item.purchase_time_id; });
            var params = {
                purchase_time_ids: ids.join(',')
            };
            _this.service.delPurchasetime(params).then(function (res) {
                loadingInstance.close();
                _this.$message.success("批量删除成功");
                _this.selectRows = [];
                _this.getList();
                window._czc.push(["_trackEvent", '订货时段设置批量删除', '订货时段设置批量删除']);
            }).catch(function (err) {
                loadingInstance.close();
                _this.$message.error(err.msg || err.message);
            });
        }, function (err) { });
    };
    PurchaseTime.prototype.operateCommand = function (command) {
        switch (command) {
            case 1:
                this.exportData();
                break;
            case 2:
                this.importData();
                break;
        }
    };
    PurchaseTime.prototype.exportData = function () {
        var _this = this;
        window._czc.push(["_trackEvent", '订货时段设置导出', '订货时段设置导出']);
        var selectIds = this.selectRows.map(function (item) { return item.purchase_time_id; });
        var exportParams = Object.assign({}, this.searchParams, {
            purchase_time_ids: selectIds.join(',')
        });
        var queryStr = Object.keys(exportParams)
            .filter(function (key) { return exportParams[key] !== undefined && exportParams[key] !== ''; })
            .map(function (key) { return key + "=" + encodeURIComponent(exportParams[key]); })
            .join('&');
        var token = this.user.token;
        var url = "/supplierclientapi/shoppingpurchasetime/export?token=" + token + "&" + queryStr;
        this.commonService.exportCheck(url)
            .then(function (res) {
            location.href = url;
        }).catch(function (err) {
            _this.$message.error(err.msg || err.message);
        });
    };
    PurchaseTime.prototype.importData = function () {
        this.dialogImportVisible = true;
        if (this.$refs.importDialog) {
            this.$refs.importDialog.setUploadType('beford');
        }
    };
    PurchaseTime.prototype.importSuccess = function () {
        this.isImportSuccessHandled = true;
        this.dialogImportVisible = false;
        this.search();
    };
    PurchaseTime.prototype.onImportDialogClose = function () {
        if (this.isImportSuccessHandled) {
            this.isImportSuccessHandled = false;
            return;
        }
        if (this.$refs.importDialog && this.$refs.importDialog.isImportSuccess()) {
            this.dialogImportVisible = false;
            this.search();
        }
    };
    PurchaseTime = __decorate([
        Component({
            computed: __assign({}, mapGetters({
                "user": "user"
            })),
            components: {
                'list-header': Header,
                'import-dialog': ImportDialog
            }
        })
    ], PurchaseTime);
    return PurchaseTime;
}(Vue));
export default PurchaseTime;
